import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ChevronDownIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M6.265 11.322a1 1 0 0 1 1.413-.057L16 18.943l8.322-7.678a1 1 0 1 1 1.356 1.47l-8.437 7.785c-.694.64-1.788.64-2.482 0l-8.437-7.785a1 1 0 0 1-.057-1.413Z" />
  </BaseIcon>
);
